<template>
    <div class="contents murk custom-header" :class="{ landing: landingStatus, forOpenApi: hasFromOPENAPI_WEBSITE }">
        <div v-if="showMarvelMachineTitle" class="marvel-machine-container">
            <a :href="portalUrl" :target="hrefTarget"
                ><h2 class="marvel-machine-title">{{ $t('login.marvel-machine.title') }}</h2></a
            >
            <h5 class="marvel-machine-desc">{{ $t('login.marvel-machine.desc') }}</h5>
        </div>
        <a v-else-if="!isJapan" data-cy="link-main" class="logo-container" :href="portalUrl" :target="hrefTarget">
            <svgIcon icon-holder-class="logo" icon-id="nexon-logo" />
        </a>
        <span v-else class="logo-container">
            <svgIcon icon-holder-class="logo" icon-id="nexon-logo" />
        </span>

        <!-- A/B test for launcher -->
        <h5
            class="custom-title text-uppercase"
            :class="{
                hide:
                    routeName !== 'login' &&
                    routeName !== 'create-account' &&
                    routeName !== 'global-simple-signup' &&
                    routeName !== 'global-simple-login' &&
                    routeName !== 'unified-login' &&
                    routeName !== 'unified-signup',
            }"
        >
            <router-link
                v-if="
                    routeName === 'login' ||
                        routeName === 'create-account' ||
                        routeName === 'unified-login' ||
                        routeName === 'unified-signup'
                "
                data-cy="link-login"
                :to="{ name: 'login', query: utmParams }"
                class="login"
                :class="{ active: routeName === 'login' || routeName === 'unified-login' }"
            >
                {{ $t('login.login') }}
            </router-link>
            <router-link
                v-if="
                    routeName === 'login' ||
                        routeName === 'create-account' ||
                        routeName === 'unified-login' ||
                        routeName === 'unified-signup'
                "
                data-cy="link-create"
                :to="{ name: 'create-account', query: utmParams }"
                class="create"
                :class="{ active: routeName === 'create-account' || routeName === 'unified-signup' }"
            >
                {{ $t('create-account.create') }}
            </router-link>
            <router-link
                v-if="routeName === 'global-simple-signup' || routeName === 'global-simple-login'"
                data-cy="link-Simple-Login"
                :to="{
                    name: 'global-simple-login',
                    query: appTypeQuery,
                }"
                class="create"
                :class="{ active: routeName === 'global-simple-login' }"
            >
                {{ $t('login.login') }}
            </router-link>
            <router-link
                v-if="routeName === 'global-simple-signup' || routeName === 'global-simple-login'"
                data-cy="link-Simple-Signup"
                :to="{
                    name: 'global-simple-signup',
                    query: appTypeQuery,
                }"
                class="login"
                :class="{ active: routeName === 'global-simple-signup' }"
            >
                {{ $t('create-account.create') }}
            </router-link>
        </h5>
        <!-- A/B test for launcher -->

        <h4 v-if="subTitleText" class="text-center" :class="{ 'spaced-newlines': spaceNewlines }">
            {{ subTitleText }}
        </h4>
        <div class="contents-wrapper"><slot /></div>
    </div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
/* eslint-disable no-unused-vars */
// import setABTest from '@/plugins/ab-test-helper';

export default {
    name: 'AccountContainer',
    components: {
        svgIcon,
    },
    props: {
        subTitleText: {
            type: String,
            default: '',
        },
        spaceNewlines: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasFromOPENAPI_WEBSITE() {
            if (typeof window.sessionStorage !== 'undefined') {
                return !!window.sessionStorage.getItem('from_openapi_website');
            }
            return false;
        },
        portalUrl() {
            return this.isFromMarvelMachine
                ? `${this.$store.state.configurations.host}/maplestory/marvel-machine`
                : this.$store.state.configurations.portalUrl;
        },
        hrefTarget() {
            return this.$store.state.channel === 'web' ? '_self' : '_blank';
        },
        routeName() {
            return this.$route.name;
        },
        checkLanding() {
            const { landing } = this.$route.query,
                prodID = this.$route.query.prod_id;
            return (
                landing === 'true' &&
                (prodID === '40000' ||
                    prodID === '10100' ||
                    prodID === '10200' ||
                    (prodID === '50203') | (prodID === '59739'))
            );
        },
        landingStatus() {
            return this.$store.state.landing;
        },
        isMobile() {
            return this.$store.state.isMobile;
        },
        appTypeQuery() {
            let query = this.$route.query;
            return query.app_type
                ? query
                : this.isMobile
                ? { ...query, app_type: 'toy' }
                : { ...query, app_type: 'toy_community' };
        },
        utmParams() {
            return this.$store.state.utmParams;
        },
        isJapan() {
            return environment.region === 'japan';
        },
        showMarvelMachineTitle() {
            return this.isFromMarvelMachine && (this.routeName === 'login' || this.routeName === 'create-account');
        },
    },
    mounted() {},
    created() {
        this.commitLanding();

        let hasFromOPENAPI_WEBSITE = false;
        try {
            if (typeof window.sessionStorage !== 'undefined') {
                hasFromOPENAPI_WEBSITE = !!window.sessionStorage.getItem('from_openapi_website');
            }
        } catch (e) {
            console.warn('occurse to error from openapi bypass variable hasFromOPENAPI_WEBSITE ', e);
            hasFromOPENAPI_WEBSITE = false;
        }

        // redirect to simple signup for MOD
        if (
            ['create-account', 'unified-signup'].includes(this.routeName) &&
            this.$route.query.simple_signup !== undefined &&
            this.$route.query.simple_signup === 'true' &&
            !hasFromOPENAPI_WEBSITE
        ) {
            window.location.href = `https://${process.env.VUE_APP_SIGNIN_HOST}/signup`;
        }

        // set up A/B test. setABTest(product_Id, landing(true/false), Array of partnerkeys, string of original partnerkey);
        // remember to add class with partneykey to global.css (format: product-(product_id)-(landing or null)-(partnerkey));
        // remember to add assets to image background folder
        // setABTest(10100, true, ['MK383SVG011M35484', 'MK383SVG011M35482'], 'MK383SVG011M35483');
    },
    methods: {
        commitLanding() {
            if (this.checkLanding) {
                return this.$store.commit('setLandingPage', this.checkLanding);
            }
        },
    },
};
</script>

<style lang="less">
.launcher {
    .contents {
        padding-top: 40px;
    }
    .contents-wrapper {
        margin-bottom: 150px;
    }
}
.web {
    .contents-wrapper {
        margin-bottom: 300px;
    }
}
.toy,
.developers {
    .logo-container {
        margin: 0 auto 30px !important;
        display: block;
    }
}

@media (max-width: 1024px) {
    .web {
        #createAccount {
            .contents-wrapper {
                margin-bottom: 350px;
            }
        }
    }
}
@media (max-width: 740px) {
    .launcher {
        #createAccount {
            .contents-wrapper {
                margin-bottom: 250px;
            }
        }
    }
    .web {
        #createAccount {
            .contents-wrapper {
                margin-bottom: 500px;
            }
        }
    }
}

.contents {
    max-width: 740px;
    min-width: 320px;
    margin: 0 auto;
    padding: 80px 20px 40px;

    &.forOpenApi {
        width: 360px;
    }

    h4 {
        text-transform: capitalize;
        color: #fff;
        &.spaced-newlines {
            white-space: pre-line;
        }
    }
    &.narrow {
        max-width: 400px;
        .logo-container {
            width: 118px;
            margin: 0 auto;
            display: block;
        }
        &-sm {
            max-width: 360px;
        }
    }

    .contents-wrapper {
        border-top: 1px solid fade(#fff, 10%);
        margin-top: 20px;
        padding-top: 15px;
        position: relative;
    }
    .logo-container {
        width: 118px;
    }
    .logo {
        width: 118px;
        height: 18px;
    }
}
@media (max-width: 1024px) {
    .contents {
        padding-top: 40px;
    }
}
@media (max-width: 740px) {
    .contents {
        max-width: 400px;
        .contents-wrapper {
            margin-bottom: 500px;
        }
        .logo-container {
            width: 118px;
            margin: 0 auto;
            display: block;
        }
    }
}
.custom-header {
    .logo-container {
        display: block;
        margin-bottom: 15px;
    }
    .custom-title {
        display: block;
        color: fade(#fff, 50%);
        font-weight: bold;
        position: relative;
        margin-bottom: -1px;
        margin-top: 30px;
        a {
            display: inline-block;
            padding: 13px 10px;
            &.active {
                color: fade(#fff, 100%);
                border-bottom: 2px solid #0077ff;
            }
        }
    }
    .marvel-machine-container {
        width: 550px;
        a {
            display: inline-block;
        }
        .marvel-machine-title {
            color: white;
            font-weight: 600;
            margin-top: 5px;
            margin-bottom: 0;
        }
        .marvel-machine-desc {
            margin-top: 5px;
            color: white;
            font-weight: 600;
            text-transform: none;
            font-size: 18px;
        }
    }
    #login-link,
    #create-account-link {
        display: none !important;
    }
}
@media (max-width: 740px) {
    .custom-header {
        .marvel-machine-container {
            width: 100%;

            .marvel-machine-title {
                margin-top: 20px;
                font-size: 25px;
            }

            .marvel-machine-desc {
                margin-top: 10px;
                font-size: 16px;
            }
        }
    }
}
.login,
.create-account {
    .landing {
        width: 460px;
        padding: 50px 50px 80px;
        position: relative;
        background-color: fade(#141414, 90%);
        border-radius: 5px;
        .contents-wrapper {
            margin: 0 !important;
        }
        .column.pull-left {
            max-width: 400px !important;
            .input-container {
                width: 360px;
            }
        }
        .column.pull-right {
            max-width: 400px !important;
            .third-party-container {
                width: 360px;
            }
            .wordmark-third-party {
                width: 100%;
                margin-left: 10px;
            }
        }
        .captcha-box {
            transform: scale(1.19) !important;
            margin-bottom: 20px !important;
        }
        .legacy-tpa-checkbox {
            display: none;
        }
        #page-main-heading {
            border-top: 1px solid fade(#fff, 10%);
            padding-top: 20px;
        }
        @media (max-width: 740px) {
            padding: 40px 20px;
            .contents-wrapper {
                margin-bottom: 150px !important;
            }

            .column.pull-left {
                max-width: 320px !important;
            }
            .column.pull-right {
                max-width: 320px !important;
            }
            .input-container,
            .third-party-container {
                width: 320px !important;
            }
            .captcha-box {
                transform: scale(1.06) !important;
                margin-bottom: 10px !important;
            }
            #page-main-heading {
                margin-top: 30px;
            }
            .logo-container {
                margin: 0;
            }
            .product-logo {
                position: absolute !important;
            }
        }
        @media (max-width: 420px) {
            margin-top: 0;
            width: auto;
        }
        #login-link,
        .product-logo {
            top: -135px !important;
            height: 75px !important;
        }
    }
}

#login,
#createAccount {
    .custom-header {
        .contents-wrapper {
            margin-top: 0;
        }
    }
}
.launcher {
    #login,
    #createAccount {
        .custom-header {
            .logo-container {
                display: none;
            }
        }
    }
}
.has-prod-id {
    .logo-container {
        margin: 0;
    }
    .product-logo {
        top: -130px !important;
        height: 75px !important;
    }
}
.marvel-machine-container ~ .contents-wrapper {
    .product-logo {
        top: -145px !important;
    }
}
@media (max-width: 740px) {
    .marvel-machine-container ~ .contents-wrapper {
        .product-logo {
            top: -144px !important;
            height: 55px !important;
        }
    }
}
</style>
